import { render, staticRenderFns } from "./SignInMFASetup.vue?vue&type=template&id=c0cf7bba&scoped=true&lang=html"
import script from "./SignInMFASetup.vue?vue&type=script&lang=js"
export * from "./SignInMFASetup.vue?vue&type=script&lang=js"
import style0 from "./SignInMFASetup.vue?vue&type=style&index=0&id=c0cf7bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cf7bba",
  null
  
)

export default component.exports